import React, { useState } from "react";
import Accordion from "canvas-core-react/lib/Accordion";
import AccordionItem from "canvas-core-react/lib/AccordionItem";
import { useTranslation } from "react-i18next";

import AddUser from "./addUser";
import ErrorMessage from "../../shared/custom-components/errorMessage";
import Modal from "../../utils/customModal";
import StepButtons from "./stepButtons";
import { infoContainer } from "../../utils/functions";

const UserForm = ({
  initialState = [],
  country,
  institution,
  nextStep,
  previousStep,
  reviewMode,
}) => {
  const [users, setUsers] = useState(initialState);
  const [error, setError] = useState(false);
  const [{ searchable, mode }, setState] = useState({
    ...defaultState,
    mode: getInitialMode(users.length, reviewMode),
  });

  const { t } = useTranslation();

  const onAddUser = (user) => {
    if (error) setError(false);
    const newUsers = [...users, user];
    setUsers(newUsers);
    handleMode(newUsers.length < 10 ? modes[1] : null);
  };

  const getElement = (child) =>
    mode !== modes[3] ? (child ? AccordionItem : Accordion) : "div";

  const Element = getElement();
  const ChildElement = getElement(true);

  const onSubmit = () => {
    if (!users.length) setError(true);
    else nextStep(users);
  };

  const handleMode = (value) => {
    setState({ ...defaultState, mode: value });
  };

  const handleSearchable = (searchable) => {
    setState({ mode: modes[2], searchable });
  };

  return (
    <>
      <h3 className="form-title">{t(`${baseName}title`)}</h3>
      {error && (
        <ErrorMessage className="w-100 mb-5" error={t(`${baseName}error`)} />
      )}
      {users.length > 0 && (
        <Element
          className="w-100 accordion-title-fix mb-5"
          {...(mode !== modes[3] && { headingLevel: "h6" })}
        >
          <ChildElement title="Usuarios agregados">
            {users.map((user, index) => (
              <div className="mt-4" key={index + 1}>
                <AddUser initialState={user} userNumber={index + 1} readOnly />
              </div>
            ))}
          </ChildElement>
        </Element>
      )}

      {mode === "edit" && (
        <AddUser
          onAddUser={onAddUser}
          key={users.length}
          userNumber={users.length + 1}
          searchable={searchable}
          institution={institution}
          country={country}
        />
      )}

      <div className="d-flex w-100 align-items-end" style={{ marginTop: -50 }}>
        {mode === modes[1] && (
          <button
            className="add-user-last-step"
            onClick={() => handleMode(modes[0])}
          >
            {t(`${baseName}addUser`)}
          </button>
        )}
        {mode !== modes[3] && (
          <StepButtons nextStep={onSubmit} previousStep={previousStep} />
        )}
      </div>

      <Modal show={mode === modes[0]}>
        <div className="molda-setting-content">
          {modalContent(handleSearchable)}
        </div>
      </Modal>
    </>
  );
};

export default UserForm;

const baseName = "registerProvider.forms.user.";

const defaultState = { searchable: false, mode: null };

const modalContent = (onClick) => {
  return infoContainer(
    "Agregar usuario",
    `El usuario se encuentra activo en Scotia en linea?`,
    {
      SelBtn: { text: "Si", action: () => onClick(true) },
      formBtn: { text: "No", action: () => onClick(false) },
    }
  );
};

const modes = {
  0: "modal",
  1: "canAdd",
  2: "edit",
  3: "review",
};

const getInitialMode = (usersLen, review) => {
  if (review) return modes[3];
  if (usersLen === 0) return modes[0];
  if (usersLen >= 10) return null;
  return modes[1];
};
